import { Injectable }  from '@angular/core';
import { Http }  from '@angular/http';

import { CookieUtils } from '../shared/cookieutils';

import {BaseService} from './base.service';
import {BaseServiceExceptionHandler} from './base-service-exception-handler';

@Injectable()
export class GetTeamSummariesForSeasonService extends BaseService {

	constructor($http: Http, $cookies: CookieUtils, BaseServiceExceptionHandler: BaseServiceExceptionHandler) {
		super($http, $cookies, BaseServiceExceptionHandler);
	}

    public get(requestObj: any) {
        let urlStr: string = 'league/' + requestObj.leagueId + '/season/' + requestObj.seasonId + '/team/list?rank=' + requestObj.includeRank;
        if (requestObj.divisionId) {
            urlStr += '&divisionid=' + requestObj.divisionId;
        }
        if (requestObj.usePlayoffRank === true || requestObj.usePlayoffRank === false) {
            urlStr += '&playoff=' + requestObj.usePlayoffRank;
        }
        if (requestObj.sortBy) {
            urlStr += '&sort=' + requestObj.sortBy;
        }

	    return this.sendRequest('GET',
                                urlStr,
                         	    null,
                                null,
                                false);
    }

}
